// URL-owned context: tabs and browser history cannot silently change another editor's scope.
export const experienceStorefrontKey = () => {
  const match = window.location.pathname.match(/^\/storefronts\/([^/]+)\/experience(?:\/|$)/);
  return match ? decodeURIComponent(match[1]) : new URLSearchParams(window.location.search).get('storefront') || '';
};

const legacyToCanonical = (raw = '') => {
  const path = String(raw || '').replace(/^\/website/, '');
  if (!path || path === '/') return '';
  if (path === '/pages') return '/content/pages';
  if (path.startsWith('/page/')) return `/content${path}`;
  if (path === '/blogs') return '/content/blogs';
  if (path === '/popup') return '/content/popups';
  if (path === '/header') return '/navigation/header';
  if (path === '/footer') return '/navigation/footer';
  if (path === '/settings') return '/configuration';
  return path;
};

export const experiencePath = (path = '', key = experienceStorefrontKey()) => {
  const normalized = legacyToCanonical(path);
  return key ? `/storefronts/${encodeURIComponent(key)}/experience${normalized}` : `/website${String(path || '').replace(/^\/website/, '')}`;
};

export const storefrontSiteUrl = (storefront) => {
  const domain = String(storefront?.domain || '').trim();
  if (!domain) return '';
  try {
    const url = new URL(/^https?:\/\//i.test(domain) ? domain : `https://${domain}`);
    return ['http:', 'https:'].includes(url.protocol) ? url.origin : '';
  } catch { return ''; }
};
